import React, {Fragment, useState} from "react";
import ordersApi from "../../../../api/ordersApi";

/**
 * Displays a text box for the purchaser to enter their email if they have an existing account.
 * Once submitted, the user will claim ownership of the order with the given confirmation number.
 * @param {string} orderConfirmationToken
 * @returns {JSX.Element}
 * @constructor
 */
function LinkOrderToUser({ orderConfirmationToken }) {
  const [userEmail, setUserEmail] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLinked, setIsLinked] = useState(false);

  async function submit() {
    setErrorMessage(null);

    try {
      await ordersApi.claimOwnership(userEmail, orderConfirmationToken);
      setIsLinked(true);
    }
    catch (ex) {
      if ((ex.status === 403 || ex.status === 404) && ex.responseJSON.error)
        setErrorMessage(ex.responseJSON.error);
      else
        setErrorMessage("An error has occurred while attempting to link your order. Please contact support if you continue to have issues.");
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {!isLinked &&
        <Fragment>
          <div className="next-button-txt text-muted text-center">
            If you have an existing account, enter your email address to link this order to your account now!
          </div>

          <input
            id="existingUserEmail"
            className="form-control form-control-inputs my-2"
            placeholder="Email"
            onChange={e => { setUserEmail(e.target.value); }}
          />

          <button onClick={submit} className="teal button-link next-button-txt next-step-button text-center px-lg-3 mb-3 align-self-center lg-100-sm-75">
            Link now!
          </button>
        </Fragment>
      }

      {isLinked &&
        <div className="next-button-txt text-center" style={{ color: "green" }}>
          Success! This order has been linked to your account.
        </div>
      }

      {errorMessage &&
        <div className="next-button-txt text-center" style={{ color: "red" }}>
          {errorMessage}
        </div>
      }
    </div>
  );
}

export default LinkOrderToUser;